"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var data_1 = require("../../data");
var paper_1 = __importDefault(require("../../ui/paper"));
var MyAdd = function (props) {
    var UI = props.UI, linkBack = props.linkBack, insertPromise = props.insertPromise, _a = props.initial, initial = _a === void 0 ? {} : _a, onUpdate = props.onUpdate, message = props.message, _b = props.PaperComponent, PaperComponent = _b === void 0 ? paper_1["default"] : _b, _c = props.withPaper, withPaper = _c === void 0 ? true : _c;
    var content = (react_1["default"].createElement(data_1.Add, { link: onUpdate || linkBack, linkBack: linkBack, promise: insertPromise, UI: function (props) { return react_1["default"].createElement(UI, __assign({ isAdd: true }, props)); }, data: __assign({}, initial), message: message }));
    if (withPaper === false) {
        return content;
    }
    return react_1["default"].createElement(PaperComponent, null, content);
};
exports["default"] = MyAdd;
